import {RefsContextType} from "../definitions/types";
import * as React from "react";
import {createContext, RefObject, useContext, useRef} from "react";

interface IProps {
    children: React.ReactNode;
}

const RefsContext = createContext<RefsContextType>({
    productDetailsAccordionRef: {} as RefObject<HTMLDivElement>,
    ratingsAccordionItemRef: {} as RefObject<HTMLDivElement>,
    ratingFilterContainerRef: {} as RefObject<HTMLDivElement>
})

const RefsContextProvider = ({children}: IProps) => {
    const productDetailsAccordionRef = useRef<HTMLDivElement>(null);
    const ratingsAccordionItemRef = useRef<HTMLDivElement>(null);
    const ratingFilterContainerRef = useRef<HTMLDivElement>(null);

    const defaultValue = {
        productDetailsAccordionRef,
        ratingsAccordionItemRef,
        ratingFilterContainerRef
    };

    return (
        <RefsContext.Provider value={defaultValue}>
            {children}
        </RefsContext.Provider>
    )
};

export {RefsContext, RefsContextProvider};

export const useRefsContext = () => useContext(RefsContext);